export enum SessionActionTypes {
    INIT = '@@session/INIT',
}

export interface SessionState {
    init: boolean
}
